<template>
  <div>
    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir esse item?') }}
          </div>

          <v-btn
            :disabled="deleteLoading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            class="ma-1"
            color="error"
            text
            :loading="deleteLoading"
            @click="removeCalibration"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <div class="hidden-sm-and-down">
      <div class="d-flex">
        <v-spacer></v-spacer>

        <v-fade-transition>
          <v-btn
            v-if="selected && selected.length > 0"
            depressed
            class="mb-2 mr-2 primary-button"
            dark
            @click="getZip"
          >
            Baixar certificados
          </v-btn>
        </v-fade-transition>

        <v-btn
          depressed
          class="mb-2 ml-2 primary-button"
          dark
          @click="visible = !visible"
        >
          {{ !visible ? 'Filtros' : 'Fechar filtros' }}
        </v-btn>
      </div>
    </div>

    <v-expand-transition>
      <div v-show="visible">
        <v-row class="ma-0" dense>
          <v-col cols="12" sm="3">
            <label class="label">Instituição</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.institutionId"
              outlined
              disabled
              :items="institutions"
              item-text="name"
              item-value="id"
              placeholder="Selecione"
              append-icon="mdi-chevron-down"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Unidade</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.unidadeId"
              outlined
              :items="unidades"
              item-text="name"
              item-value="id"
              placeholder="Selecione"
              append-icon="mdi-chevron-down"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Setor</label>
            <v-autocomplete
              :search-input.sync="departmentSearch"
              @blur="departmentSearch = ''"
              hide-details="auto"
              v-model="filter.departmentIds"
              outlined
              multiple
              :items="departments"
              item-text="name"
              item-value="id"
              placeholder="Selecione"
              append-icon="mdi-chevron-down"
              class="primary-input"
              @keyup.enter="filterTable"
            >
              <template
                v-slot:selection="{ attrs, index, item, select, selected }"
              >
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  color="#BBCF20"
                  text-color="#fff"
                  small
                  @click="select"
                  @click:close="removeDepartment(index)"
                >
                  {{ item.name }}
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ item.name }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Equipamento padrão</label>
            <v-autocomplete
              :search-input.sync="standardEquipmentSearch"
              @blur="standardEquipmentSearch = ''"
              hide-details="auto"
              v-model="filter.standardEquipmentIds"
              outlined
              multiple
              :items="standardEquipments"
              item-text="name"
              item-value="id"
              placeholder="Selecione"
              append-icon="mdi-chevron-down"
              class="primary-input"
              @keyup.enter="filterTable"
            >
              <template
                v-slot:selection="{ attrs, index, item, select, selected }"
              >
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  color="#BBCF20"
                  text-color="#fff"
                  small
                  @click="select"
                  @click:close="removeStandardEquipment(index)"
                >
                  {{ item.name }}
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ item.name }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Identificação</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.identification"
              outlined
              placeholder="Digite"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Código patrimônio</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.propertyCode"
              outlined
              placeholder="Digite"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Número de série</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.serialNumber"
              outlined
              placeholder="Digite"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Equipamento</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.equipment"
              outlined
              placeholder="Digite"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Fabricante</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.manufacturer"
              outlined
              placeholder="Digite"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Modelo</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.model"
              outlined
              placeholder="Digite"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Nº O.S.</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.osNumber"
              outlined
              placeholder="Digite"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3" class="text-center">
            <label class="label"> Data de calibração </label>
            <v-row class="ma-0" no-gutters>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menuStartDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      hide-details="auto"
                      v-model="startDate"
                      v-mask="['##/##/####']"
                      placeholder="Inicial"
                      prepend-inner-icon="mdi-calendar"
                      @blur="filter.startDate = parseDate(startDate)"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input mr-1"
                      @keyup.enter="filterTable"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filter.startDate"
                    min="1900-01-01"
                    @change="save"
                    locale="pt"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="6">
                <v-menu
                  ref="menuEndDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      hide-details="auto"
                      v-model="endDate"
                      v-mask="['##/##/####']"
                      placeholder="Final"
                      prepend-inner-icon="mdi-calendar"
                      @blur="filter.endDate = parseDate(endDate)"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input mr-1"
                      @keyup.enter="filterTable"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filter.endDate"
                    min="1900-01-01"
                    @change="save"
                    locale="pt"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Calibração validada</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.validated"
              outlined
              :items="[
                {
                  text: 'Sim',
                  value: true,
                },
                {
                  text: 'Não',
                  value: false,
                },
              ]"
              item-text="text"
              item-value="value"
              placeholder="Selecione"
              append-icon="mdi-chevron-down"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">Nº certificado</label>
            <v-text-field
              hide-details="auto"
              v-model="filter.number"
              outlined
              placeholder="Digite"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="2">
            <label class="label">Aprovação</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.result"
              outlined
              :items="[
                {
                  text: 'Aprovadas',
                  value: 0,
                },
                {
                  text: 'Reprovadas',
                  value: 1,
                },
              ]"
              item-text="text"
              item-value="value"
              placeholder="Selecione"
              append-icon="mdi-chevron-down"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4">
            <label class="label">Padrão</label>
            <v-autocomplete
              :search-input.sync="usedPatternSearch"
              @blur="usedPatternSearch = ''"
              v-model="filter.usedPatternIds"
              :items="usedPatterns"
              item-text="name"
              item-value="id"
              hide-details="auto"
              outlined
              placeholder="Selecione"
              append-icon="mdi-chevron-down"
              class="primary-input"
              multiple
              ><template
                v-slot:selection="{ attrs, index, item, select, selected }"
              >
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  color="#BBCF20"
                  text-color="#fff"
                  small
                  @click="select"
                  @click:close="removeUsedPattern(index)"
                >
                  {{ item.name }}
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ item.name }}
                </span>
              </template></v-autocomplete
            >
          </v-col>
        </v-row>

        <v-col cols="12" class="d-flex justify-end">
          <v-btn
            depressed
            class="mr-2 secondary-button"
            color="#BBCF20"
            @click="filterTable"
          >
            <span>Filtrar</span>
            <v-icon class="pl-2">mdi-magnify</v-icon>
          </v-btn>

          <v-btn
            depressed
            color="#20202066"
            class="clear-button"
            @click="reset"
          >
            <span>{{ $t('Limpar') }}</span>
            <v-icon class="pl-2">mdi-cached</v-icon>
          </v-btn>
        </v-col>
      </div>
    </v-expand-transition>

    <div class="wrapper desktop">
      <v-data-table
        :loading="loading"
        :loading-text="$t('Carregando...')"
        :no-data-text="$t('Nenhum item encontrado')"
        :headers="headers"
        :items="certifieds"
        v-model="selected"
        show-select
        hide-default-footer
        :items-per-page="pageSize"
        :header-props="headerProps"
        class="main-table"
      >
        <template #[`item.identification`]="{ item }">
          {{ item.equipment ? item.equipment.identification : 'sem registro' }}
        </template>

        <template #[`item.equipment`]="{ item }">
          {{ item.equipment ? item.equipment.name : 'sem registro' }}
        </template>

        <template #[`item.serviceOrderNumber`]="{ item }">
          {{ item.serviceOrder ? item.serviceOrder.number : 'sem registro' }}
        </template>

        <template #[`item.date`]="{ item }">
          {{ formatDate(item.date) }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                :color="
                  item.serviceOrder.closeServiceOrderDateTime
                    ? '#B9CE1E'
                    : '#F5F5F5'
                "
                dark
                small
                depressed
                v-bind="attrs"
                v-on="on"
                :to="`/editServiceOrder/${item.serviceOrderId}`"
                target="_blank"
              >
                <v-icon
                  :color="
                    item.serviceOrder.closeServiceOrderDateTime
                      ? '#fff'
                      : '#2A8EA4'
                  "
                  small
                >
                  mdi-view-module
                </v-icon>
              </v-btn>
            </template>
            <span>Ver ordem de serviço</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                :color="item.result == 1 ? '#B14949' : '#BBCF20'"
                dark
                small
                depressed
                :to="`/calibration/v2/print?id=${item.id}`"
                target="_blank"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small> mdi-printer </v-icon>
              </v-btn>
            </template>
            <span>Ver certificado</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="institution.userType != 5 && institution.userType != 4"
                class="ma-1"
                color="#0F3565"
                dark
                small
                depressed
                :to="`/calibration/v2/manage?id=${item.id}`"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Editar certificado</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="institution.userType != 5 && institution.userType != 4"
                class="ma-1"
                color="#B14949"
                dark
                small
                depressed
                @click.stop="deleteCalibration(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small> mdi-trash-can-outline </v-icon>
              </v-btn>
            </template>
            <span>Remover certificado</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span>
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from '../../../../../Utils/FormatDate'
import ApiService from '../../../../../services/ApiService.js'
import GeneralService from '../../../../../services/GeneralService'

export default {
  data: () => ({
    selected: [],
    loading: false,
    deleteDialog: false,
    visible: false,
    page: 1,
    pageSize: 10,
    totalPages: 1,
    sizes: [10, 25, 50],
    totalItems: 0,
    standardEquipmentSearch: '',
    departmentSearch: '',
    usedPatternSearch: '',
    startDate: null,
    endDate: null,
    totalItensOnPage: 0,
    certifieds: [],
    usedPatterns: [],
    filter: {
      institutionId: null,
      unidadeId: null,
      departmentIds: [],
      standardEquipmentIds: [],
      identification: '',
      propertyCode: '',
      serialNumber: '',
      model: '',
      osNumber: null,
      equipment: '',
      manufacturer: '',
      validated: null,
      number: null,
      result: null,
      usedPatternIds: [],
      startDate: null,
      endDate: null,
      page: 1,
      pageSize: 10,
    },
    headers: [
      { text: '', align: 'center', value: '', sortable: false },
      {
        text: 'Identificação',
        align: 'center',
        value: 'identification',
        sortable: false,
      },
      {
        text: 'Equipamento',
        align: 'center',
        value: 'equipment',
        sortable: false,
      },
      {
        text: 'Nº OS',
        align: 'center',
        value: 'serviceOrderNumber',
        sortable: false,
      },
      {
        text: 'Data Calibração/Certificado',
        align: 'center',
        value: 'date',
        sortable: false,
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
    institution: {},
    deleteLoading: false,
    departmentLoading: false,
    manufacturerLoading: false,
    unidadeLoading: false,
    standardEquipmentLoading: false,
    institutionLoading: false,
    departmentLoading: false,
    manufacturers: [],
    unidades: [],
    standardEquipments: [],
    institutions: [],
    departments: [],
    generalService: new GeneralService(),
    loggedUser: {},
  }),

  async created() {
    this.loggedUser = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.filter.institutionId = this.institution.id

    if (this.institution.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    await Promise.all([
      this.getInstitutions(),
      this.getDepartments(),
      this.getStandardEquipment(),
      this.getManufacturers(),
      this.getUsedPatterns(),
    ])

    this.list()
  },

  methods: {
    removeDepartment(item) {
      this.filter.departmentIds.splice(item, 1)
      this.filter.departmentIds = [...this.filter.departmentIds]
    },
    removeUsedPattern(item) {
      this.filter.usedPatternIds.splice(item, 1)
      this.filter.usedPatternIds = [...this.filter.usedPatternIds]
    },

    removeStandardEquipment(item) {
      this.filter.standardEquipmentIds.splice(item, 1)
      this.filter.standardEquipmentIds = [...this.filter.standardEquipmentIds]
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.filter.startDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.filter.startDate).toISOString().substr(0, 10)
      this.endDate = this.formatInputDate(this.filter.endDate)
      this.$refs.menuEndDate.save(date)
    },

    getManufacturers() {
      this.manufacturerLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institution.id}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufacturerLoading = false
        })
        .catch(() => {
          this.manufacturerLoading = false
        })
    },

    async getZip() {
      this.$toast(
        `${this.$t('Imprimindo registros')}: ${this.selected.length} ${this.$t(
          'selecionados'
        )}`
      )
      const ids = this.selected.map((x) => x.id)
      await this.apiService
        .post(`calibration/v2/certified/pdf/lot`, { ids })
        .then((response) => {
          var pedfResult = 'data:application/zip;base64,' + response.content
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute('download', `Calibrações`)
          document.body.appendChild(link)
          link.click()
          this.selected = []
        })
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institution.id}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institution.id
        )

      this.standardEquipmentLoading = false
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institution.id}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/listActive/${this.institution.id}`)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
    },

    async getUsedPatterns() {
      this.apiService
        .get(`calibration/v2/pattern/getUsedPatterns/${this.institution.id}`)
        .then((response) => {
          this.usedPatterns = response.content
        })
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    removeCalibration() {
      this.deleteLoading = true
      this.apiService
        .delete(`calibration/v2/certified/${this.currentCalibration.id}`)
        .then((response) => {
          this.deleteLoading = false
          this.deleteDialog = false
          this.list()
        })
        .catch(() => {
          this.deleteLoading = false
          this.deleteDialog = false
        })
    },

    filterTable() {
      this.page = 1
      this.list()
    },

    list() {
      this.loading = true

      this.apiService
        .post('calibration/v2/certified/paginate', this.filter)
        .then((response) => {
          this.certifieds = response.content.data

          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.pager.pageSize
          this.totalPages = response.content.pager.totalPages
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    reset() {
      this.filter = {
        institutionId: this.institution.id,
      }
      this.startDate = null
      this.endDate = null
      this.list()
    },

    deleteCalibration(item) {
      this.currentCalibration = item
      this.deleteDialog = true
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.list()
    },
    page() {
      this.filter.page = this.page
      this.list()
    },
  },
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
}
.pagination {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>
